module.exports = __webpack_public_path__ + "img/1560230187.a55c87ea.jpg";